import {z} from 'zod';
import {BaseIntegrationSchema} from './common';

export const LinkedInIntegrationSchema = BaseIntegrationSchema.extend({
  type: z.literal('linkedin'),
  adAccountId: z.number().optional(),
  adClicksConfig: z
    .object({
      lastImport: z.date().optional(),
      lookbackMonths: z.number().optional(),
    })
    .optional(),
  oauth: z.object({
    issuedAt: z.date(),
    refreshToken: z.string(),
    refreshTokenExpiresIn: z.number(),
    scopes: z.string().array(),
  }),
});

export type LinkedInIntegration = z.infer<typeof LinkedInIntegrationSchema>;
